import React from "react";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const goSection = (id) => {
    if (window.location.pathname !== "/") {
      window.location.href = `/#${id}`;
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const fl = [
    { to: "/florida", label: "Florida (Statewide)" },
    { to: "/regions/sarasota", label: "Sarasota" },
    { to: "/regions/tampa", label: "Tampa" },
    { to: "/regions/st-petersburg", label: "St. Petersburg" },
    { to: "/regions/naples", label: "Naples" },
    { to: "/regions/palm-beach", label: "Palm Beach" },
    { to: "/regions/boca-raton", label: "Boca Raton" },
    { to: "/regions/fort-lauderdale", label: "Fort Lauderdale" },
    { to: "/regions/miami", label: "Miami" },
    { to: "/regions/orlando", label: "Orlando" },
    { to: "/regions/winter-park", label: "Winter Park" },
    { to: "/regions/jacksonville", label: "Jacksonville" },
  ];

  const beyond = [
    { to: "/regions/los-angeles", label: "Los Angeles" },
    { to: "/regions/new-york", label: "New York" },
    { to: "/regions/san-francisco", label: "San Francisco" },
    { to: "/regions/the-hamptons", label: "The Hamptons" },
    { to: "/london", label: "London" },
    { to: "/dubai", label: "Dubai" },
    { to: "/muenchen", label: "München" },
  ];

  return (
    <footer data-testid="site-footer" className="bg-[#33302A] text-[#F5F0E8]">
      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-14 sm:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <p className="font-serif-le text-2xl tracking-tight">
            Elite <span className="italic text-[#C8A878]">Swiss</span>
          </p>
          <p className="text-sm text-[#B9AF9E] mt-4 max-w-xs leading-relaxed">
            Household staffing agency headquartered in Sarasota, Florida — serving
            families and homeowners throughout Florida, across the USA and internationally.
          </p>
          <div className="space-y-3 text-sm mt-6">
            <a data-testid="footer-email-link" href="mailto:info@elite-swiss.com" className="flex items-center gap-2 link-line w-fit">
              <Mail className="w-4 h-4 text-[#C8A878]" strokeWidth={1.5} />
              info@elite-swiss.com
            </a>
            <a data-testid="footer-phone-link" href="tel:+13055294140" className="flex items-center gap-2 link-line w-fit">
              <Phone className="w-4 h-4 text-[#C8A878]" strokeWidth={1.5} />
              +1 (305) 529-4140
            </a>
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#C8A878] mb-5">Agency</p>
          <div className="space-y-3 text-sm">
            <Link data-testid="footer-home-link" to="/" className="block link-line w-fit">Home</Link>
            <Link data-testid="footer-about-link" to="/about" className="block link-line w-fit">About Us</Link>
            <button data-testid="footer-services-link" onClick={() => goSection("services")} className="block link-line">Hire Household Staff</button>
            <Link data-testid="footer-candidates-link" to="/candidates" className="block link-line w-fit">For Candidates</Link>
            <Link data-testid="footer-contact-link" to="/contact" className="block link-line w-fit">Contact Us</Link>
            <Link data-testid="footer-blog-link" to="/blog" className="block link-line w-fit">Journal</Link>
            <Link data-testid="footer-family-register-link" to="/register-family" className="block link-line w-fit">Register Your Family</Link>
            <Link data-testid="footer-impressum-link" to="/impressum" className="block link-line w-fit">Impressum</Link>
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#C8A878] mb-5">Florida</p>
          <div className="space-y-3 text-sm">
            {fl.map((l) => (
              <Link key={l.to} data-testid={`footer-fl-${l.to.split("/").pop()}`} to={l.to} className="block link-line w-fit">
                {l.label}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#C8A878] mb-5">Beyond Florida</p>
          <div className="space-y-3 text-sm">
            {beyond.map((l) => (
              <Link key={l.to} data-testid={`footer-beyond-${l.to.split("/").pop()}`} to={l.to} className="block link-line w-fit">
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#8A7F6D]">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} Elite Swiss LLC · 7255 Bee Ridge Rd, Sarasota, FL 34245</span>
          <span className="uppercase tracking-[0.2em]">Discretion · Quality · Personal Care</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
